<div class="ac-dialog-backdrop show"></div>
<div class="ac-dialog show" (click)="onDialogClicked($event)" [ngStyle]="overrideStyles" ignore-accessible>
	<a class="close" *ngIf="showClose" (click)="close()" custom-tracking [track-event]="closeAnalyticsEvent"><icon type="times"></icon></a>
	<ng-template #dialogTemplate></ng-template>
</div>
